import { render, staticRenderFns } from "./breakpoints.vue?vue&type=template&id=994ed744"
import script from "./breakpoints.vue?vue&type=script&lang=js"
export * from "./breakpoints.vue?vue&type=script&lang=js"
import style0 from "./breakpoints.vue?vue&type=style&index=0&id=994ed744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports